<template>
    <Dialog v-model:visible="display" :modal="true" class="verification-dialog" :baseZIndex="106">
        <div class="logo logo-dark" />
        <div class="box" data-cy="pending-verification">
            <img class="dots-top" src="/kandidaten/img/dot-pattern-top.svg" />
            <img class="dots-bottom" src="/kandidaten/img/dot-pattern-bottom.svg" />
            <div class="box-content">
                <div class="headline">
                    <h2>{{$t('change.email.headline')}}</h2>
                </div>
                <div class="verify-text">
                    <p>{{$t('change.email.text')}}</p>
                    <div class="newmail-input">
                        <span class="p-float-label">
                            <InputText type="text"
                                       data-cy="new-email"
                                       v-model="v$.emailAddress.$model"
                                       :class="{ 'p-invalid': v$.emailAddress.$invalid }" />
                            <label>{{t("change.email.newmail")}}</label>

                        </span>
                        <small class="p-error"
                               v-for="(error, index) of v$.emailAddress.$errors"
                               :key="index">
                            {{error.$message}}
                        </small>
                    </div>
                    
                    <div class="success-message">
                        <div class="verification-buttons">
                            <Button :label="t('back')" @click="display = false"
                                    class="button-secondary button-rectangle" />
                            <Button :label="t('change.email.button')" @click="changeEmail"
                                    class="button-primary button-rectangle" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts" setup>

    import { defineEmits, defineExpose, getCurrentInstance, ref } from "vue";
    import { createAuthenticationService } from '@/services/authenticationService';
    import { useToast } from 'primevue/usetoast';
    import { useI18n } from "vue-i18n";
    import useVuelidate from "@vuelidate/core";
    import { email, helpers, required } from "@vuelidate/validators";

    const emit = defineEmits(['email-verified', 'error']);
    const toaster = useToast();
    const app = getCurrentInstance();
    const display = ref(false);
    const { t } = useI18n();
    const user = ref([]);


    const service = createAuthenticationService(app);

    const show = async () => {
        display.value = true;
    };

    const rules = {
        emailAddress: {
            required: helpers.withMessage(t("Eingabe wird benötigt"), required),
            email: {
                required: helpers.withMessage(
                    "Es wird eine valide E-Mail-Adresse benötigt.",
                    email
                ),
            },
        },
    };

    const v$ = useVuelidate(rules, user);

    const validate = () => {
        v$.value.$touch();
        if (v$.value.$invalid) {
            return v$.value.$error;
        }
    };
    const changeEmail = async () => {
        if (validate())
            return;
        let success = false
        try {
            success = await service.changeEmail(app, user.value.emailAddress);
        } catch {
            success = false;
        }
        if (success) {
            toaster.add({
                severity: "success",
                summary: t("change.mail.toast.success.title"),
                detail: t("change.mail.toast.success.text"),
                life: 5000,
            });
            emit('email-changed');
            display.value = false;
        } else {
            toaster.add({
                severity: "error",
                summary: t("change.mail.toast.error.title"),
                detail: t("change.mail.toast.error.text"),
                life: 5000,
            });
        }
        
    }


    defineExpose({
        show
    });
</script>
